import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '@core/services/api.service';
import { Doctor } from '@shared/models/doctor';
import { ApiDoctorsResponse } from '@shared/models/interface/api-doctors-response';

@Injectable({
	providedIn: 'root'
})
export class DoctorsService {
	constructor(private readonly apiService: ApiService) {}

	getDoctors(companyId: number, procedureId: number): Observable<Doctor[]> {
		return this.apiService
			.request({
				selector: 'getDoctors',
				queryParams: {
					companyId,
					procedureId
				},
				showLoader: false
			})
			.pipe(
				map((response: ApiDoctorsResponse) =>
					response.Result.map(doctor => ({
						Id: doctor.Id,
						Name: doctor.Name,
						Licence: doctor.LicenseNumber
					}))
				)
			);
	}
}
